export default __webpack_public_path__ + "static/media/models8.91de4cb9.jfif";